import React from 'react';

class TextureItem extends React.Component {
    getImage = () => {
        const { entry } = this.props;
        const textureAsset = entry.get();

        return (
            <img 
                src={textureAsset.baseTexture.source.src}
                alt={entry.id}
            />
        );
    }

    checkIfCurrent = () => {
        const { entry , currentAsset } = this.props;
        const { id } = entry;

        return id === currentAsset;
    }

    handlePickAsset = () => {
        const { onPickAsset, entry } = this.props;
        const { id } = entry;
        onPickAsset(id);
    }

    render = () => {
        // Check if this item is the selected item.
        const isActive = ( 
            this.checkIfCurrent() ?
            "active"
            : ""
        );

        return (
            <div className={`asset-picker-item asset-picker-texture ${isActive}`} onClick={this.handlePickAsset} >
                { this.getImage() }
            </div>
        )   
    }
}

TextureItem.defaultProps = {
    entry: {},
    currentAsset: ''
};

export default TextureItem;